import {
  ColdTemp,
  HotTemp,
  NormalTemp,
  Typography,
} from "@thingsw/pitta-design-system";
import { Color } from "@thingsw/pitta-modules";
import React from "react";

interface TempStatusProps {
  temp: number;
  isCelcius?: boolean;
  colors: Color;
}

const TempStatus = ({ temp, isCelcius, colors }: TempStatusProps) => {
  const tempIcon =
    temp >= 70 ? (
      <HotTemp
        style={{
          width: 14,
          height: 14,
        }}
      />
    ) : temp >= 0 ? (
      <NormalTemp
        style={{
          width: 14,
          height: 14,
        }}
      />
    ) : (
      <ColdTemp
        style={{
          width: 14,
          height: 14,
        }}
      />
    );

  const tempString = isCelcius
    ? `${temp}°C`
    : `${((temp * 9) / 5 + 32).toFixed(0)}°F`;

  return (
    <>
      {tempIcon}
      <Typography variant="Caption" htmlColor={colors.primary["1"]}>
        {tempString}
      </Typography>
    </>
  );
};

export default TempStatus;
